export default __webpack_public_path__ + "static/media/Me.8a5f024d.jpg";